import $ from "jquery"

/**
 * Scripts for matchHeight sections
 */

document.addEventListener('DOMContentLoaded', function () {
 const steps = document.querySelectorAll('.step');
 const contents = document.querySelectorAll('.step-content');

 // Set the first step and content as active on page load
 if (steps.length > 0 && contents.length > 0) {
  steps[0].classList.add('active');
  contents[0].classList.add('active');
 }

 steps.forEach(step => {
  step.addEventListener('click', function () {
   // Remove active class from all steps and contents
   steps.forEach(s => s.classList.remove('active'));
   contents.forEach(c => c.classList.remove('active'));

   // Add active class to the clicked step and corresponding content
   this.classList.add('active');
   document.querySelector(`.step-content[data-step="${this.getAttribute('data-step')}"]`).classList.add('active');
  });
 });


  $('.steps').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          autoplay: true,
          autoplaySpeed: 3000,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          autoplay: true,
          autoplaySpeed: 3000,
        }
      },
    ]
  });
});
